import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatDialog } from '@angular/material';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { AddSupervisorToVirtualCourseComponent } from '../add-supervisor-to-virtual-course/add-supervisor-to-virtual-course.component';
import { RegisterStudentCourseComponent } from '../register-student-course/register-student-course.component';
import { IError } from 'src/app/interfaces/error.interface';
import { StudentListComponent } from 'src/app/pages/sessions/student-sessions-checkout/student-list/student-list.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-course-session-list',
  templateUrl: './course-session-list.component.html',
  styleUrls: ['./course-session-list.component.css']
})
export class CourseSessionListComponent implements OnInit {

  Sessions = [];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  dataSource = new MatTableDataSource<any>();

  displayedColumns: string[] = [
    "TeacherAttendance",
    "sessionDatePersian",
    "sessionTime",
    "status",
    "adobeConnect",
    "function"
  ];

  changedAttendanceList: any = [];
  allSessionsAttendanceStatus: boolean | null = null;

  constructor(
    private dialog: MatDialog,
    private courseService: CourseService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private curDialog: MatDialogRef<CourseSessionListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log(this.data);
    this.getCourseSession();
  }

  changeAttendanceStatus(element: any): void
  {
    const addedItem = this.changedAttendanceList.filter(e => e.AllSessionId == element.Id)[0];
    if(addedItem == undefined)
    {
      const newAttendanceStatus = {
        AllSessionId: element.Id,
        StatusId: element.AllSessionStatusId == 91 ? 92 : 91,
        IsMakeUp: element.IsMakeUp
      }
  
      this.changedAttendanceList.push(newAttendanceStatus);
    }else
    {
      addedItem.StatusId = addedItem.StatusId == 91 ? 92 : 91
    }
  }

  onChangeAllSessionsAttendanceStatus(): void
  {
    this.changedAttendanceList = [];
    const list = this.dataSource.data;
    
    list.forEach(item => {
      item.Attendance = this.allSessionsAttendanceStatus;
      const newAttendanceStatus = {
        AllSessionId: item.Id,
        StatusId: this.allSessionsAttendanceStatus == true ? 91 : 92,
        IsMakeUp: item.IsMakeUp
      }
  
      this.changedAttendanceList.push(newAttendanceStatus);
    });
    this.dataSource.data = list;
  }
  submitCheckout(): void
  {
    
    var data = {
      AttendanceStatus: this.changedAttendanceList,
      ParentTermId: this.data.parentTermId,
      BranchEncryptId: this.data.branchEncryptId,
      DateNow: new Date().toISOString(),
    };

    this.courseService.saveAttendanceWithNoDate(data).subscribe({
      next: () =>
      {
        this.snackBar.OpenSnackBar("حضور و غیاب ثبت شد", "ok", 3000, SoundEnum.beep);
        this.getCourseSession();
      },
      error: (err: HttpErrorResponse) =>
      {
        this.errorList = this.errorService.getErrorList(err.error);
      }
    });
  }

  getCourseSession() {

    this.courseService.getCourseSession(this.data.CourseId).subscribe(result => {
      this.allSessionsAttendanceStatus = null;
      this.changedAttendanceList = [];

      result.map(element => {
        element["Attendance"] = element.AllSessionStatusId == 91;
      });

      this.dataSource.data = result;
    })

  }

  createVirtualSessionForCourse(courseId: number) {
    this.errors = new Array();

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از ساخت جلسات مجازی برای همه جلسات اطمینان دارید؟",
      alert: null,
      yesLabel: "بله",
      noLabel: "خیر"
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "400px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {

          let data = {
            CourseId: courseId
          };
          this.courseService.createMeeting(data).subscribe(() => {
            this.getCourseSession();
            this.snackBar.OpenSnackBar(
              'جلسات مجازی با موفقیت ایجاد گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
          },
            err => {
              // this.errObject = this.errorService.getError(err);
              // this.param = this.errorService.objectError(this.errObject);
              // this.errors = this.errorService.returnError(err);
              this.errorList = this.errorService.getErrorList(err.error);
            })
        }
      });

  }

  showStudents(element: any): void {

    let command: any = {
      CourseId: element.CourseId,
      AllSessionId: element.Id,
      CourseStatusId: element.CourseStatusId,
      RoomId: element.RoomId,
      TeacherUserEncryptId: element.TeacherUserEncryptId,
      FullName: element.TeacherName,
      LevelName: element.LevelName,
      TimeStart: element.StartTime,
      TimeEnd: element.EndTime,
      Result: element.Result
    };
    this.dialog.open(StudentListComponent, {
      data: command,
      disableClose: true,
      width: "800px",
    })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.getCourseSession();
        }
      });
  }

  // subRequests(data: any): void {
  //   this.dialog.open(, {
  //     data: { sessionId: data.Id },
  //     width: "800px"
  //   })
  //     .afterClosed()
  //     .subscribe(() => { });
  // }

  createVirtualSessionForSession(courseId: number, sessionId: number) {
    this.errors = new Array();

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از ساخت جلسات مجازی برای همه جلسات اطمینان دارید؟",
      alert: null,
      yesLabel: "بله",
      noLabel: "خیر"
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "400px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          let data = {
            CourseId: courseId,
            SessionId: sessionId
          };
          this.courseService.createMeetingForOneSession(data).subscribe(() => {
            this.getCourseSession();
            this.snackBar.OpenSnackBar(
              'جلسه مجازی با موفقیت ایجاد گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
          },
            err => {
              // this.errObject = this.errorService.getError(err);
              // this.param = this.errorService.objectError(this.errObject);
              // this.errors = this.errorService.returnError(err);
              this.errorList = this.errorService.getErrorList(err.error);
            })
        }
      });

  }

  AddStudentToVirtualCourse(course: any) {
    course.AddStudentToVirtualCourse = true;
    course.AddStudentToVirtualSession = false;
    this.dialog.open(RegisterStudentCourseComponent, {
      width: "900px",
      data: course
    });
  }

  AddTeacherToVirtualCourse() {
    this.errors = new Array();

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از اضافه کردن استاد به همه جلسات اطمینان دارید؟",
      alert: null,
      yesLabel: "بله",
      noLabel: "خیر"
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "400px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          let data = {
            CourseId: this.data.CourseId
          };
          this.courseService.addTeacherToVirtualCourse(data).subscribe(() => {
            this.getCourseSession();
            this.snackBar.OpenSnackBar(
              'استاد با موفقیت به جلسات مجازی اضافه گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
          },
            err => {
              // this.errObject = this.errorService.getError(err);
              // this.param = this.errorService.objectError(this.errObject);
              // this.errors = this.errorService.returnError(err);
              this.errorList = this.errorService.getErrorList(err.error);
            })
        }
      });
  }

  // AddSupervisorToVirtualCourse(course: any) {
  //   this.errors = new Array();

  //   let confirm: IConfirm = {
  //     accept: true,
  //     message: "آیا از اضافه کردن ناظر به همه جلسات اطمینان دارید؟",
  //     alert: null,
  //     yesLabel: "بله",
  //     noLabel: "خیر"
  //   };

  //   this.dialog
  //     .open(ConfirmComponent, {
  //       width: "400px",
  //       data: confirm
  //     })
  //     .afterClosed()
  //     .subscribe(res => {
  //       if (res) {
  //         this.errors = new Array();
  //         let data = {
  //           CourseId: course.id
  //         };
  //         this.courseService.addTeacherToVirtualCourse(data).subscribe(() => {
  //           this.getCourseSession();
  //           this.snackBar.OpenSnackBar(
  //             'استاد با موفقیت به جلسات مجازی اضافه گردید',
  //             "ok",
  //             5000,
  //             SoundEnum.beep
  //           );
  //         },
  //           err => {
  //             this.errObject = this.errorService.getError(err);
  //             this.param = this.errorService.objectError(this.errObject);
  //             this.errors = this.errorService.returnError(err);
  //           })
  //       }
  //     });
  // }

  AddStudentToVirtualSession(course: any, session: any) {
    course.AddStudentToVirtualCourse = false;
    course.AddStudentToVirtualSession = true;
    course.Session = session;
    this.dialog.open(RegisterStudentCourseComponent, {
      width: "900px",
      data: course
    });
  }

  AddSupervisorToVirtualCourse(course: any) {
    course.AddStudentToVirtualCourse = false;
    course.AddStudentToVirtualSession = true;
    this.dialog.open(AddSupervisorToVirtualCourseComponent, {
      width: "350px",
      data: course
    });
  }

  onNoClick() {
    this.curDialog.close();
  }

}
